<!--
  页面头部组件
  // title: 标题
-->
<template>
  <div class="header">
    <van-nav-bar :title="title" @click-left="goBack">
      <template v-if="!isMiniprogram" slot="left">
        <van-icon size="22" name="/images/back@3x.png" />
      </template>
      <template v-if="showRule" slot="right">
        <van-button plain size="small" type="primary" @click="isShow = true">活动规则</van-button>
      </template>
    </van-nav-bar>
    <!-- 规则弹窗 -->
    <rules-modal v-model="isShow" :rule-description="ruleDescription"></rules-modal>
  </div>
</template>

<script>
import { NavBar } from 'vant'
import RulesModal from '@/components/RulesModal'
export default {
  components: {
    [NavBar.name]: NavBar,
    RulesModal
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    // 是否跳转到APP
    backToApp: {
      type: Boolean,
      default: false
    },
    ruleDescription: {
      type: String,
      default: ''
    },
    showRule: {
      type: Boolean,
      default: false
    },
    // 跳转的路径
    to: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      isShow: false,
      client: this.$route.query.client
    }
  },
  methods: {
    goBack() {
      if (this.backToApp) {
        this.appGoBack()
      } else {
        this.$router.push(this.to)
      }
    },
    appGoBack() {
      try {
        if (this.client === 'android') {
          // eslint-disable-next-line no-undef
          invitationWebViewAppInterface.goBack()
        } else if (this.client === 'ios') {
          window.webkit.messageHandlers.observe.postMessage('close')
        } else {
          this.$router.push(this.to)
        }
      } catch (e) {
        this.$notify({ type: 'danger', message: e.toString(), duration: 2000 })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: #ffffff;
  text-align: center;
  font-size: 18px;
  /deep/ .van-nav-bar__left {
    font-size: 16px;
    padding-left: 10px;
    .van-nav-bar__text {
      color: #333333;
    }
  }
  /deep/ .van-nav-bar__title {
    font-size: 18px;
    font-weight: normal;
  }
  /deep/ .van-nav-bar .van-icon {
    color: #333333;
  }

  /deep/ .van-nav-bar__right {
    padding-right: 3px;
    button {
      border: none;
      font-size: 14px;
      color: inherit;
    }
  }

  .van-nav-bar {
    background-color: transparent;
    border: none;
    box-shadow: none;
    &.van-hairline--bottom::after {
      border-bottom-width: 0;
    }
  }
}
</style>
